export const API_URL = "https://outdoorprop.wpengine.com/k-api";
export const RECAPTCHA_KEY = "6Lf3ne4gAAAAABBKXmeRIlI37gW81tVXzePZl6uQ";
